import React, { useMemo } from "react";

import moment from "moment";
import Highlighter from "react-highlight-words";
import StyledScrollbar from "../../../../../Common/UIComponents/StyledScrollbar";

import { ReactComponent as CorrectiveActionPreventionIcon } from "../../../../../../assets/images/environment/CorrectiveActionPreventionIcon.svg";

import "./UpcomingSchedulesList.css";

export default function UpcomingSchedulesList({ dates }) {
  const schedules = useMemo(() => {
    const dateTextList = dates.map((date) => moment(date).format("Do MMMM"));
    const highlight = dates.map((date) => moment(date).format("Do"));
    return { dateTextList, highlight };
  }, [dates]);

  return (
    <div className="UpcomingSchedulesList">
      <div className="CorrectiveActionPreventionIcon">
        <CorrectiveActionPreventionIcon />
      </div>
      <div className="UpcomingSchedulesList__ListContainer">
        <div className="UpcomingSchedulesList__Title">
          <CorrectiveActionPreventionIcon className="UpcomingSchedulesList__Icon" />
          <span className="UpcomingSchedulesList__Text">
            Upcoming Schedules
          </span>
        </div>
        <StyledScrollbar className="UpcomingSchedulesList__ListScrollbar">
          <ul className="UpcomingSchedulesList__List">
            {schedules.dateTextList.map((schedule, idx) => (
              <li key={idx}>
                <Highlighter
                  highlightClassName="UpcomingSchedulesList__List--highlighted"
                  searchWords={schedules.highlight}
                  autoEscape
                  textToHighlight={schedule}
                />
              </li>
            ))}
          </ul>
        </StyledScrollbar>
      </div>
    </div>
  );
}
